import { Ship } from "lucide-react";

export const Transportation = () => (
  <section
    className="px-6 py-16 md:px-16 md:py-24"
    data-testid="transportation-section"
  >
    <div className="mx-auto max-w-4xl">
      <p className="mb-4 text-xs uppercase tracking-[0.3em] text-[#7A6A5E]">Transportation</p>
      <h2 className="font-display text-3xl font-light tracking-tight text-[#3F3A32] md:text-5xl">
        Getting home
      </h2>

      <div className="mt-16 border border-[#DCD3C0] bg-[#FAF7F0] p-10" data-testid="transport-back">
        <Ship className="h-6 w-6 -scale-x-100 text-[#7A6A5E]" strokeWidth={1.5} />
        <p className="mt-8 text-xs uppercase tracking-[0.2em] text-[#7A7264]">Getting home</p>
        <p className="mt-3 font-display text-2xl font-light tracking-tight text-[#3F3A32]">
          The day after
        </p>
        <p className="mt-4 text-base font-light leading-relaxed text-[#5E574B]">
          Enjoy a slow breakfast, served between 08:00–11:00, before we say our goodbyes.
          Below you'll find all available departures from Sandhamn to Stavsnäs. As
          everyone's plans may differ, please book the departure that suits you best.
        </p>

        <p className="mt-8 text-xs uppercase tracking-[0.2em] text-[#7A7264]">Departure times</p>
        <p className="mt-2 font-display text-xl font-light tracking-wide text-[#3F3A32]" data-testid="departure-times">
          10:05 · 12:05 · 14:35 · 17:05
        </p>
        <p className="mt-2 text-sm font-light text-[#948B7B]">
          All crossings take approximately 30 minutes.
        </p>

        <p className="mt-8 text-xs uppercase tracking-[0.2em] text-[#7A7264]">Book your return trip</p>
        <a
          href="https://boka.battaxi.se"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="book-return-link"
          className="mt-2 inline-block text-base font-light text-[#7A6A5E] underline decoration-[#C9BFA9] underline-offset-4 transition-colors hover:text-[#3F3A32]"
        >
          Book Sandhamn → Stavsnäs
        </a>

        <p className="mt-8 text-xs uppercase tracking-[0.2em] text-[#7A7264]">Prefer a private taxi boat?</p>
        <p className="mt-2 text-base font-light leading-relaxed text-[#5E574B]">
          If you prefer more flexibility, you can also book your own private taxi boat from Sandhamn.
        </p>
        <a
          href="https://www.sandhamntaxicharter.se"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="private-taxi-link"
          className="mt-2 inline-block text-base font-light text-[#7A6A5E] underline decoration-[#C9BFA9] underline-offset-4 transition-colors hover:text-[#3F3A32]"
        >
          Book a private taxi boat
        </a>
      </div>
    </div>
  </section>
);
